import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'shared/components/ExternalLink';
import { mergeClasses } from 'shared/utils/mergeClasses';
import privacyPolicy from '../../../assets/pdfs/Regulations-and-Privacy-Policy-v2.pdf';
import whistleblowerPolicy from '../../../assets/pdfs/Whistleblower-Policy.pdf';

type LegalAgreementsVariant = 'standard' | 'externalOffer';
interface LegalAgreementsProps {
  className?: string;
  variant?: LegalAgreementsVariant;
}

export const LegalAgreements: FC<LegalAgreementsProps> = ({
  className = '',
  variant = 'standard',
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'auth:legalAgreement',
  });
  const isExernalOffer = variant === 'externalOffer';
  const linkVariant = isExernalOffer ? 'light-gray' : 'primary';

  return (
    <div
      className={mergeClasses(
        'flex w-full flex-col gap-1 text-xs text-gray',
        isExernalOffer ? 'text-gray-400' : 'text-gray',
        className,
      )}
    >
      <div className="flex">
        <p>
          <span>{t('byCreatingAccount')}</span>
          <ExternalLink
            href={privacyPolicy}
            variant={linkVariant}
            text={t('terms')}
            className="font-medium"
          />
          <span> {t('and')} </span>
          <ExternalLink
            href={`${privacyPolicy}#page=11`}
            variant={linkVariant}
            text={t('policy')}
            className="font-medium"
          />
          <span>. {t('accountRegistration')}</span>
        </p>
      </div>

      <p>
        <span>{t('administrativeInfo')}</span>
        <ExternalLink
          href={`mailto:${t('legalEmail')}`}
          variant={linkVariant}
          text={t('legalEmail')}
        />
        <span>. {t('contactInfo')}</span>
        <ExternalLink
          href={`mailto:${t('legalEmail')}`}
          variant={linkVariant}
          text={t('legalEmail')}
        />
        <span> {t('dataInspectorCopy')} </span>
        <ExternalLink
          href={`mailto:${t('dataInspectorEmail')}`}
          variant={linkVariant}
          text={t('dataInspectorEmail')}
        />
        <span>.</span>
      </p>

      <p>
        <span>{t('whistleblowerInfo.organizationAdopted')}</span>
        <span>{t('whistleblowerInfo.procedure')}</span>
        <span>{t('whistleblowerInfo.legalBasis')}</span>
        <ExternalLink
          href={whistleblowerPolicy}
          variant={linkVariant}
          text={t('whistleblowerInfo.here')}
          className="font-medium"
        />
        <span>.</span>
      </p>
    </div>
  );
};
